
module.config(function($stateProvider, $httpProvider) {

    function makeAuthResolver(permission, permissionObject, instead) {
        permission = permission && !angular.isArray(permission) ?
            [permission] : permission;
        resolver.$inject = ['$q', 'Principal', permissionObject];
        function resolver($q, Principal, permissions) {
            for (var i = 0; i < permission.length; i++) {
                if (!permissions[permission[i]]) {
                    return $q.reject({
                        reason: 'unauthorized',
                        permission: permission,
                        instead: instead,
                    });
                }
            }
            return $q.when(true);
        }
        return resolver;
    }

    $stateProvider.decorator('views', function(state, parent) {
        var views = parent(state),
            objName = state.permissionObject || 'permissions';

        angular.forEach(views, function(config, name) {
            var permission = config.permission || state.permission,
                permObjName = config.permissionObject || objName,
                resolveName, authDependencies;

            if (permission) {
                config.resolve = config.resolve || {};

                // Add _auth to all resolves, so that the authorization check
                // happens before all other resolves.  Exempt permObjName to
                // avoid circular dependency.
                for (resolveName in config.resolve) {
                    if (resolveName !== permObjName && angular.isArray(config.resolve[resolveName])) {
                        config.resolve[resolveName].splice(
                            config.resolve[resolveName].length - 1,
                            0, '_auth');
                    }
                }

                // Add auth resolve

                config.resolve._auth = makeAuthResolver(permission,
                                                        permObjName,
                                                        state.instead);
            }
        });

        return views;
    });

    $httpProvider.interceptors.push(function($injector) {
        var Principal;
        return {
            response: function(response) {
                Princpal = Principal || $injector.get('Principal');
                if (Principal) {
                    Principal.resetExpire();
                }
                return response;
            }
        };
    });
});


module.run(function($rootScope, $state, $location, Principal) {

    $rootScope.$on('$stateChangeStart', function(e, toState, toParams) {

        function goToStateWithReturnParams(name) {
            if (name === toState.name) {
                return;
            }
            e.preventDefault();
            return $state.go(name, {
                returnName: toState.name,
                returnParams: toParams,
            });
        }

        // Dont do any state transition magic for the loading state to avoid
        // a nasty infinite loop
        if (toState.name === 'loadingIdentity') {
            return;
        }

        // Transition to the loading state to load the Principal.  This will
        // make sure that the principal is resolved for every state.
        if (!Principal.resolved) {
            return goToStateWithReturnParams('loadingIdentity');
        }

        // If The principal is not logged in and the destination state does
        // not allow anon access, go to the login state.
        if (!Principal.is_authenticated && !toState.allowAnon) {
            return goToStateWithReturnParams('login');
        }

        if (toState.name === 'tokenLogin') {
            Principal.logout().then(function() {

            });
            return;
        }

        if (Principal.reset_required) {
            return goToStateWithReturnParams('resetForm');
        }

        if (Principal.update_required) {
            return goToStateWithReturnParams('updateContact');
        }

        // The home state is a virtual state; it just redirects to a number of
        // different places based on the user.
        if (toState.name === 'home') {
            e.preventDefault();
            if (Principal.permissions.indexPrograms) {
                $state.transitionTo('programs');
            } else if (Principal.program_count === 1) {
                $state.transitionTo('program.overview', {
                    slug: Principal.program_slug,
                });
            } else if (Principal.program_count > 1) {
                $state.transitionTo('myPrograms');
            } else {
                goToStateWithReturnParams('logout');
            }
            return;
        }
    });


    $rootScope.$on('$stateChangeError', function(e, toState, toParams,
                                                 fromState, fromParams,
                                                 error) {
        if (error && error.status == 401) {

            Principal.returner = $state.go.bind($state, toState.name, toParams, {
                reload: true, location: 'replace'});
            $state.go('login');
        }
    });

});
